import PropTypes from 'prop-types';

import 'components/ClickmeButtonsWrapper/ClickmeButtonsWrapper.less';

const ClickmeButtonsWrapper = ({ children }) => <div className="clickme-buttons-wrapper">{children}</div>;

ClickmeButtonsWrapper.propTypes = {
    children: PropTypes.node,
};

export default ClickmeButtonsWrapper;
